<template>
  <div
    v-show="Active"
    class="my-3"
    :QuestionNo="QuestionNo"
  >
    <div
      class="bg-white rounded border"
      :class="{'border-danger':MustError }"
    >
      <h6 class="text-break text-break-word m-3">
        <span
          v-show="isMust"
          class="text-break text-break-word text-danger ml-n2"
        >*</span>
        {{ title }}
      </h6>
      <div
        v-if="img"
        class="px-3"
      >
        <img
          :src="img"
          alt=""
          class="mw-100 h-auto rounded"
        >
      </div>
      <hr class="mx-3">
      <div class="my-3">
        <b-form-rating
          v-model="value"
          variant
          class="bg-white border-0 text-customize"
          style="font-size:2.0rem!important"
          :stars="formCategoryValueCnt > 3 ? formCategoryValueCnt : 3"
          @change="Check()"
        />
      </div>
    </div>
    <p
      v-show="ShowMustWording"
      class="text-danger font-size-md"
    >
      {{ mustAlertWording }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    QuestionNo: Number,
    title: String,
    img: String,
    must: Boolean,
    mustAlertWording: String,
    Active: Boolean,
    formCategoryValueCnt: Number
  },
  data() {
    return {
      value: '',
      ShowMustWording: false,
      MustError: false,
      isMust: this.must
    };
  },
  watch: {
    value() {
      this.$emit('UpdateAnswer', this.QuestionNo, [1], this.value.toString(), true);
      // if (
      //   this.value === null
      //   || this.value === undefined
      //   || this.value === ''
      // ) {
      //   this.$emit('FillinCount');
      // } else {
      //   this.$emit('FillinCount');
      // }
    }
  },
  methods: {
    Check() {
      const vm = this;
      if (vm.isMust && vm.value === '') {
        vm.DisplayMustError();
        return false;
      }
      vm.HideMustError();
      return true;
    },
    DisplayMustError() {
      this.ShowMustWording = true;
      this.MustError = true;
    },
    HideMustError() {
      this.ShowMustWording = false;
      this.MustError = false;
    }
  }
};
</script>
